enum LANG_TEXT {
  POPUP_REQUEST = 'POPUP_REQUEST',
  COMMON_YES = 'COMMON_YES',
  ORDER = 'ORDER',
  ORDER_SUMMARY = 'ORDER_SUMMARY',
  PAYMENT_SUMMARY = 'PAYMENT_SUMMARY',
  PRICE = 'PRICE',
  SHIPPING_FEE = 'SHIPPING_FEE',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  TOTAL_PAYMENT = 'TOTAL_PAYMENT',
  ITEMS = 'ITEMS',
  ITEM = 'ITEM',
  PREVIOUS = 'PREVIOUS',
  NEXT = 'NEXT',
  PRINT_RECEIPT = 'PRINT_RECEIPT',
  LOCATION = 'LOCATION',
  STATUS = 'STATUS',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  NOTIFICATION_NEW_ORDER_MESSAGE = 'NOTIFICATION_NEW_ORDER_MESSAGE',
  NOTIFICATION_EMPTY_STATE = 'NOTIFICATION_EMPTY_STATE',
  HOME = 'HOME',
  ORDER_MANAGEMENT = 'ORDER_MANAGEMENT',
  ORDER_HISTORY = 'ORDER_HISTORY',
  MENU_MANAGEMENT = 'MENU_MANAGEMENT',
  SETTINGS = 'SETTINGS',
  LOG_OUT = 'LOG_OUT',
  DASHBOARD = 'DASHBOARD',
  EMPTY_NEW_ORDER = 'EMPTY_NEW_ORDER',
  PARKING_LOT = 'PARKING_LOT',
  PARKING_LOT_TITLE = 'PARKING_LOT_TITLE',
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM',
  LOGIN_EMAIL_ADDRESS = 'LOGIN_EMAIL_ADDRESS',
  LOGIN_PASSWORD = 'LOGIN_PASSWORD',
  LOGIN_TITLE = 'LOGIN_TITLE',
  LOGIN_HELPER_HINT = 'LOGIN_HELPER_HINT',
  MENU = 'MENU',
  MANAGE_CATEGORY = 'MANAGE_CATEGORY',
  ADD_NEW_FOOD = 'ADD_NEW_FOOD',
  EDIT_ITEM = 'EDIT_ITEM',
  ADD_NEW = 'ADD_NEW',
  ITEM_INFORMATION = 'ITEM_INFORMATION',
  ITEM_PHOTO = 'ITEM_PHOTO',
  OPTION = 'OPTION',
  RECOMMENDED_FOOD = 'RECOMMENDED_FOOD',
  REMOVE = 'REMOVE',
  SAVE = 'SAVE',
  OPTION_NAME = 'OPTION_NAME',
  NEW_CATEGORY = 'NEW_CATEGORY',
  ADD_NEW_CATEGORY = 'ADD_NEW_CATEGORY',
  DONE = 'DONE',
  REMOVE_TEXT = 'REMOVE_TEXT',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  CONTINUE_UPDATE = 'CONTINUE_UPDATE',
  CONTINUE_UPDATE_TEXT = 'CONTINUE_UPDATE_TEXT',
  DOWNLOAD_CSV = 'DOWNLOAD_CSV',
  OPERATING_HOUR_SETTINGS = 'OPERATING_HOUR_SETTINGS',
  START_TIME = 'START_TIME',
  END_TIME = 'END_TIME',
  TIME_ERROR = 'TIME_ERROR',
  LOGIN_FAIL_MESSAGE = 'LOGIN_FAIL_MESSAGE',
  ALL = 'ALL',
  NEW = 'NEW',
  READY_FOR_PICK_UP = 'READY_FOR_PICK_UP',
  DELIVERED = 'DELIVERED',
  UPDATE_SUCCESS_MESSAGE = 'UPDATE_SUCCESS_MESSAGE',
  UPDATE_FAILED_MESSAGE = 'UPDATE_FAILED_MESSAGE',
  ACCOUNT_LOCKED_MESSAGE = 'ACCOUNT_LOCKED_MESSAGE',
  OTP_NOT_CORRECT = 'OTP_NOT_CORRECT',
  LOGIN_REQUIRED_EMAIL = 'LOGIN_REQUIRED_EMAIL',
  LOGIN_VALID_EMAIL = 'LOGIN_VALID_EMAIL',
  LOGIN_REQUIRED_PASSWORD = 'LOGIN_REQUIRED_PASSWORD',
  VERIFY_YOUR_EMAIL = 'VERIFY_YOUR_EMAIL',
  TIME_REMAINING = 'TIME_REMAINING',
  SEND_OTP = 'SEND_OTP',
  SECONDS = 'SECONDS',
  SUBMIT = 'SUBMIT',
  NO_MENUS = 'NO_MENUS',
  DELIVERING = 'DELIVERING',
  WARNING_DUPLICATE_TITLE = 'WARNING_DUPLICATE_TITLE',
  QUANTITY = 'QUANTITY',
  CONFIRM_DAMAGED_ORDER = 'CONFIRM_DAMAGED_ORDER',
  ORDER_CANCELLATION = 'ORDER_CANCELLATION',
  CONFIRM_DAMAGED_TITLE = 'CONFIRM_DAMAGED_TITLE',
  CONFIRM_DAMAGED_DESCRIPTION = 'CONFIRM_DAMAGED_DESCRIPTION',
  PARTIAL_CANCELLATION = 'PARTIAL_CANCELLATION',
  FULL_CANCELLATION = 'FULL_CANCELLATION',
  PARTIAL_CANCELLATION_TITLE = 'PARTIAL_CANCELLATION_TITLE',
  PARTIAL_CANCELLATION_DESCRIPTION = 'PARTIAL_CANCELLATION_DESCRIPTION',
  CONFIRM_PARTIAL = 'CONFIRM_PARTIAL',
  FULL_CANCELLATION_TITLE = 'FULL_CANCELLATION_TITLE',
  FULL_CANCELLATION_DESCRIPTION = 'FULL_CANCELLATION_DESCRIPTION',
  CANCELLED = 'CANCELLED',
  ACTUAL_DAMAGE_QUANTITY = 'ACTUAL_DAMAGE_QUANTITY',
  ACTUAL_REFUND_QUANTITY = 'ACTUAL_REFUND_QUANTITY',
  DELIVERY_FEE = 'DELIVERY_FEE',
  DELIVERY_FEE_ETC = 'DELIVERY_FEE_ETC',
  PRINT = 'PRINT',
  TOTAL = 'TOTAL',
  FOOD_REVENUE = 'FOOD_REVENUE',
  TOTAL_REVENUE = 'TOTAL_REVENUE',
  TOTAL_ORDER = 'TOTAL_ORDER',
  TOTAL_ORDER_AMOUNT = 'TOTAL_ORDER_AMOUNT',
  OVERALL = 'OVERALL',
  ASTROLAB = 'ASTROLAB',
  TOTAL_DELIVERED_ORDER = 'TOTAL_DELIVERED_ORDER',
  TOTAL_DAMAGED_ORDER = 'TOTAL_DAMAGED_ORDER',
  TOTAL_DAMAGED_FEE = 'TOTAL_DAMAGED_FEE',
  TOTAL_CANCELLED_ORDER = 'TOTAL_CANCELLED_ORDER',
  PRINTER_SETTINGS = 'PRINTER_SETTINGS',
  BLUETOOTH_ENABLED = 'BLUETOOTH_ENABLED',
  BLUETOOTH_DISABLED = 'BLUETOOTH_DISABLED',
  BLUETOOTH_PERMISSION_REQUIRED = 'BLUETOOTH_PERMISSION_REQUIRED',
  BLUETOOTH_PERMISSION_DENIED = 'BLUETOOTH_PERMISSION_DENIED',
  BLUETOOTH_NOT_SUPPORTED = 'BLUETOOTH_NOT_SUPPORTED',
  DEFAULT_PRINTER = 'DEFAULT_PRINTER',
  PRINTER_WORD = 'PRINTER_WORD',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  NO_PRINTER_CONFIGURED = 'NO_PRINTER_CONFIGURED',
  ADD_PRINTER = 'ADD_PRINTER',
  SCANNING = 'SCANNING',
  NEARBY_PRINTERS = 'NEARBY_PRINTERS',
  SCANNING_FOR_PRINTERS = 'SCANNING_FOR_PRINTERS',
  NO_PRINTERS_FOUND = 'NO_PRINTERS_FOUND',
  CLOSE = 'CLOSE',
  REMOVE_PRINTER_QUESTION = 'REMOVE_PRINTER_QUESTION',
  REMOVE_PRINTER_DESCRIPTION = 'REMOVE_PRINTER_DESCRIPTION',
  REMOVE_CONFIRM = 'REMOVE_CONFIRM',
  PRINTER_SETUP_GUIDE = 'PRINTER_SETUP_GUIDE',
  PRINTER_SETUP_STEP1 = 'PRINTER_SETUP_STEP1',
  PRINTER_SETUP_STEP2 = 'PRINTER_SETUP_STEP2',
  PRINTER_SETUP_STEP3 = 'PRINTER_SETUP_STEP3',
  PRINTER_SETUP_STEP4 = 'PRINTER_SETUP_STEP4',
  PRINTER_SETUP_STEP5 = 'PRINTER_SETUP_STEP5',
  FAILED_TO_SCAN_PRINTERS = 'FAILED_TO_SCAN_PRINTERS',
  FAILED_TO_CONNECT_PRINTER = 'FAILED_TO_CONNECT_PRINTER',
  PRINTER_LAN_CONNECT_FAILED = 'PRINTER_LAN_CONNECT_FAILED',
  UNKNOWN_CONNECTION_ERROR = 'UNKNOWN_CONNECTION_ERROR',
  INVALID_PRINTER_TARGET = 'INVALID_PRINTER_TARGET',
  FAILED_TO_REMOVE_PRINTER = 'FAILED_TO_REMOVE_PRINTER',
  PRINT_VIA_IP = 'PRINT_VIA_IP',
  USER_MENUS = 'USER_MENUS',
  REGULAR_ORDERS = 'REGULAR_ORDERS',
  REGULAR_ORDER = 'REGULAR_ORDER',
  REGULAR_PRE_ORDERS = 'REGULAR_PRE_ORDERS',
  REGULAR_PRE_ORDER = 'REGULAR_PRE_ORDER',
  SPECIAL_ORDERS = 'SPECIAL_ORDERS',
  SPECIAL_PRE_ORDERS = 'SPECIAL_PRE_ORDERS',
  FOOD_TRUCKS = 'FOOD_TRUCKS',
  ASTROLAB_STORE = 'ASTROLAB_STORE',
  GAME_SCHEDULE = 'GAME_SCHEDULE',
  PRE_ORDERS = 'PRE_ORDERS',
  PRE_ORDER_RULES = 'PRE_ORDER_RULES',
  SEATS_MANAGEMENT = 'SEATS_MANAGEMENT',
  CATEGORIES_MANAGEMENT = 'CATEGORIES_MANAGEMENT',
  AVAILABLE = 'AVAILABLE',
  PRE_ORDER = 'PRE_ORDER',
  BULK_ACTIONS = 'BULK_ACTIONS',
  BULK_ACTIONS_DESCRIPTION = 'BULK_ACTIONS_DESCRIPTION',
  BULK_ACTION_CONFIRMATION_TITLE = 'BULK_ACTION_CONFIRMATION_TITLE',
  BULK_ACTION_CONFIRMATION_DESCRIPTION = 'BULK_ACTION_CONFIRMATION_DESCRIPTION',
  BULK_ACTION_ERROR_AVAILABILITY = 'BULK_ACTION_ERROR_AVAILABILITY',
  BULK_ACTION_ERROR_PRE_ORDER = 'BULK_ACTION_ERROR_PRE_ORDER',
  FOR_ALL_ITEMS = 'FOR_ALL_ITEMS',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  AVAILABILITY = 'AVAILABILITY',
  PRE_ORDER_STATUS = 'PRE_ORDER_STATUS',
  PRE_ORDER_LIST = 'PRE_ORDER_LIST',
  // Preorder Rules
  PREORDER_RULES = 'PREORDER_RULES',
  PRE_ORDER_ACCEPTANCE = 'PRE_ORDER_ACCEPTANCE',
  PRE_ORDER_TIME_SLOTS = 'PRE_ORDER_TIME_SLOTS',
  // AT = 'AT',
  PRE_ORDER_ACCEPTANCE_AT = 'PRE_ORDER_ACCEPTANCE_AT',
  REMINDER_AT = 'REMINDER_AT',
  INCREMENTS = 'INCREMENTS',
  BEFORE = 'BEFORE',
  GAME_STARTS = 'GAME_STARTS',
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  // Client Email Contacting
  CLIENT_EMAIL_CONTACTING = 'CLIENT_EMAIL_CONTACTING',
  ORDER_FOR_HIM_HERSELF = 'ORDER_FOR_HIM_HERSELF',
  ORDER_FOR_OTHER_SENDER = 'ORDER_FOR_OTHER_SENDER',
  GIFT_NOTIFICATION_RECEIVER = 'GIFT_NOTIFICATION_RECEIVER',
  ORDER_SUCCESS_EMAIL_CONFIRMATION = 'ORDER_SUCCESS_EMAIL_CONFIRMATION',
  GAME_DAY_EMAIL_CONFIRMATION = 'GAME_DAY_EMAIL_CONFIRMATION',
  ORDER_DELIVERED_EMAIL_CONFIRMATION = 'ORDER_DELIVERED_EMAIL_CONFIRMATION',
  ORDER_SUCCESS_EMAIL_CONFIRMATION_TO_SENDER = 'ORDER_SUCCESS_EMAIL_CONFIRMATION_TO_SENDER',
  GAME_DAY_EMAIL_CONFIRMATION_TO_SENDER = 'GAME_DAY_EMAIL_CONFIRMATION_TO_SENDER',
  ORDER_DELIVERED_EMAIL_CONFIRMATION_TO_SENDER = 'ORDER_DELIVERED_EMAIL_CONFIRMATION_TO_SENDER',
  GAMEDAY_YOU_WILL_HAVE_A_GIFT_FROM_SENDER = 'GAMEDAY_YOU_WILL_HAVE_A_GIFT_FROM_SENDER',
  TODAY_YOU_WILL_HAVE_A_GIFT_FROM_SENDER = 'TODAY_YOU_WILL_HAVE_A_GIFT_FROM_SENDER',
  ORDER_SUMMARY_GIFT_DELIVERED_FROM_SENDER = 'ORDER_SUMMARY_GIFT_DELIVERED_FROM_SENDER',
  // RemindersF
  FOOD_TRUCK_REMINDERS = 'FOOD_TRUCK_REMINDERS',
  ASTROLAB_REMINDERS = 'ASTROLAB_REMINDERS',
  SUMMARY_UPDATES = 'SUMMARY_UPDATES',
  IF_NEW_ORDERS_ARE_PLACED = 'IF_NEW_ORDERS_ARE_PLACED',
  GAME_DAY_REMINDER = 'GAME_DAY_REMINDER',
  EXTRA_REMINDERS = 'EXTRA_REMINDERS',
  EVERY = 'EVERY',
  BEFORE_AT = 'BEFORE_AT',
  WHEN_STORE_SWITCH_TO_ONLINE = 'WHEN_STORE_SWITCH_TO_ONLINE',
  FOR_GAMEDAY_WHEN_PRE_ORDER_TIME_CLOSES = 'FOR_GAMEDAY_WHEN_PRE_ORDER_TIME_CLOSES',
  SAME_GAMEDAY_MORNING = 'SAME_GAMEDAY_MORNING',
  UNSUCCESS_EMAIL_CONFIRMATION = 'UNSUCCESS_EMAIL_CONFIRMATION',
  UNSUCCESS_EMAIL_CONFIRMATION_TO_SENDER = 'UNSUCCESS_EMAIL_CONFIRMATION_TO_SENDER',
  UNSUCCESS_GIFT_FROM_SENDER = 'UNSUCCESS_GIFT_FROM_SENDER',
  // User Menus
  CATEGORIES = 'CATEGORIES',
  RECO = 'RECO',
  ADD_RECOMMEND_LIMIT = 'ADD_RECOMMEND_LIMIT',
  MAX_BANNER_LIMIT = 'MAX_BANNER_LIMIT',
  FOOD = 'FOOD',
  BANNER = 'BANNER',
  ON_OFF = 'ON_OFF',
  YOU_HAVE_UNSAVED_CHANGES = 'YOU_HAVE_UNSAVED_CHANGES',
  SAVING = 'SAVING',
  APP_PREVIEW_IPHONE_14 = 'APP_PREVIEW_IPHONE_14',
  EMPTY_PRE_ORDER = 'EMPTY_PRE_ORDER',
  MANAGE_CATEGORIES = 'MANAGE_CATEGORIES',
  MOVE_TO_CATEGORY = 'MOVE_TO_CATEGORY',
  GAME = 'GAME',
  DELIVERY_STARTS = 'DELIVERY_STARTS',
  PRINT_TIME = 'PRINT_TIME',
  ORDERS_DELIVERABLE = 'ORDERS_DELIVERABLE',
  ATTEND = 'ATTEND',
  GAME_IN = 'GAME_IN',
  WEEK_DAY = 'WEEK_DAY',
  WEEK_END = 'WEEK_END',
  HOLIDAY = 'HOLIDAY',
  IN_RELATION_WITH_GAME_STARTS = 'IN_RELATION_WITH_GAME_STARTS',
  SINCE = 'SINCE',
  UNTIL = 'UNTIL',
  START_TIME_MUST_BE_AFTER_DELIVERY_TIME = 'START_TIME_MUST_BE_AFTER_DELIVERY_TIME',
  PLEASE_SELECT_BOTH_TIMES = 'PLEASE_SELECT_BOTH_TIMES',
  // Pre-order Modal
  PRE_ORDER_CONFIRM = 'PRE_ORDER_CONFIRM',
  PRE_ORDER_EMAIL_DESCRIPTION = 'PRE_ORDER_EMAIL_DESCRIPTION',
  PRE_ORDER_BULK_WARNING = 'PRE_ORDER_BULK_WARNING',
  PRE_ORDER_ACCEPTANCE_SINCE_EXCEEDS_ADMIN_RULE = 'PRE_ORDER_ACCEPTANCE_SINCE_EXCEEDS_ADMIN_RULE',
  PRE_ORDER_ACCEPTANCE_UNTIL_EXCEEDS_ADMIN_RULE = 'PRE_ORDER_ACCEPTANCE_UNTIL_EXCEEDS_ADMIN_RULE',
  ORDERS_DELIVERABLE_EXCEEDS_ADMIN_RULE = 'ORDERS_DELIVERABLE_EXCEEDS_ADMIN_RULE',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  ACCEPT_TERMS_PRE_ORDER = 'ACCEPT_TERMS_PRE_ORDER',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  PLEASE_ACCEPT_TERMS = 'PLEASE_ACCEPT_TERMS',
  INVALID_EMAIL = 'INVALID_EMAIL',
  UPDATE_EMAIL_ERROR = 'UPDATE_EMAIL_ERROR',
  EMAIL_REQUIRED = 'EMAIL_REQUIRED',
  MAX_EMAILS_EXCEEDED = 'MAX_EMAILS_EXCEEDED',
  ALL_FOOD_TRUCKS = 'ALL_FOOD_TRUCKS',
  FOOD_TRUCK_FILTER = 'FOOD_TRUCK_FILTER',
  SELECTED = 'SELECTED',
  NUMBER_OF_STORES = 'NUMBER_OF_STORES',
  MULTI_ORDER = 'MULTI_ORDER',
  DATE_FILTER = 'DATE_FILTER',
  ORDER_TOTAL = 'ORDER_TOTAL',
  NOTI_MAX_BANNER = 'NOTI_MAX_BANNER',
  SORT_BY_ORDER_TIME = 'SORT_BY_ORDER_TIME',
  SORT_BY_DELIVERY_TIME = 'SORT_BY_DELIVERY_TIME',
  SEARCH_BY_ORDER_TIME = 'SEARCH_BY_ORDER_TIME',
  SEARCH_BY_DELIVERY_TIME = 'SEARCH_BY_DELIVERY_TIME',
  MULTIPLE_EMAILS_HINT = 'MULTIPLE_EMAILS_HINT',
  BULK_UPDATE_ERROR = 'BULK_UPDATE_ERROR',
  HOME_SEARCH_PLACEHOLDER = 'HOME_SEARCH_PLACEHOLDER',
  HOME_SUGGESTED = 'HOME_SUGGESTED',
  NO_FOODS_FOUND = 'NO_FOODS_FOUND',
  SEARCH_BY_ORDER_ID = 'SEARCH_BY_ORDER_ID',
  SEARCH = 'SEARCH',
  RESTAURANT_NAME = 'RESTAURANT_NAME',
  LATER = 'LATER',
  WHEN_ITS_READY = 'WHEN_ITS_READY',
}

export { LANG_TEXT };
